export default [
    {
        path: '/boxes/:id',
        name: 'box',
        component: () => import( /* webpackChunkName: "box" */ '@/views/file/Box.vue')
    },
    {
        path: '/boxes',
        name: 'boxes',
        component: () => import( /* webpackChunkName: "boxes" */ '@/views/file/Boxes.vue')
    },
    {
        path: '/bpTags',
        name: 'bpTags',
        component: () => import( /* webpackChunkName: "bpTags" */ '@/views/file/BpTags.vue')
    },
    {
        path: '/bpTags/summary',
        name: 'bpTagsSummary',
        component: () => import( /* webpackChunkName: "bpTagsSummary" */ '@/views/file/BpTagsSummary.vue')
    },
    {
        path: '/bpTags/add',
        name: 'bpTagAdd',
        component: () => import( /* webpackChunkName: "bpTag" */ '@/views/file/BpTag.vue')
    },
    {
        path: '/bpTags/:id',
        name: 'bpTag',
        component: () => import( /* webpackChunkName: "bpTag" */ '@/views/file/BpTag.vue')
    },
    {
        path: '/bpTags/:id/summary',
        name: 'bpTagSummary',
        component: () => import( /* webpackChunkName: "bpTagSummary" */ '@/views/file/BpTagSummary.vue')
    },
    {
        path: '/categories/list',
        name: 'categories',
        component: () => import( /* webpackChunkName: "categories" */ '@/views/file/maintenance/Categories.vue')
    },
    {
        path: '/categories/add',
        name: 'categoryAdd',
        component: () => import( /* webpackChunkName: "category" */ '@/views/file/maintenance/Category.vue')
    },
    {
        path: '/categories/edit/:id',
        name: 'category',
        component: () => import( /* webpackChunkName: "category" */ '@/views/file/maintenance/Category.vue')
    },
    {
        path: '/categoryYear',
        name: 'categoryYear',
        component: () => import( /* webpackChunkName: "categoryYear" */ '@/views/file/CategoryYear.vue')
    },
    {
        path: '/completionMonth',
        name: 'completionMonth',
        component: () => import( /* webpackChunkName: "completionMonth" */ '@/views/file/CompletionMonth.vue')
    },
    {
        path: '/completions',
        name: 'completions',
        component: () => import( /* webpackChunkName: "completions" */ '@/views/file/Completions.vue')
    },
    {
        path: '/departments/add',
        name: 'departmentAdd',
        component: () => import( /* webpackChunkName: "department" */ '@/views/file/maintenance/Department.vue')
    },
    {
        path: '/departments/edit/:id',
        name: 'department',
        component: () => import( /* webpackChunkName: "department" */ '@/views/file/maintenance/Department.vue')
    },
    {
        path: '/departments/list',
        name: 'departments',
        component: () => import( /* webpackChunkName: "departments" */ '@/views/file/maintenance/Departments.vue')
    },
    {
        path: '/eventTypes/add',
        name: 'eventTypeAdd',
        component: () => import( /* webpackChunkName: "eventType" */ '@/views/file/maintenance/EventType.vue')
    },
    {
        path: '/eventTypes/edit/:id',
        name: 'eventType',
        component: () => import( /* webpackChunkName: "eventType" */ '@/views/file/maintenance/EventType.vue')
    },
    {
        path: '/eventTypes/list',
        name: 'eventTypes',
        component: () => import( /* webpackChunkName: "eventTypes" */ '@/views/file/maintenance/EventTypes.vue')
    },
    {
        path: '/events/add',
        name: 'addEvents',
        component: () => import( /* webpackChunkName: "addEvents" */ '@/views/file/AddEvents.vue')
    },
    {
        path: '/eventsByDate',
        name: 'eventsByDate',
        component: () => import( /* webpackChunkName: "eventsByDate" */ '@/views/file/EventsByDate.vue')
    },
    {
        path: '/files/:id/emails',
        name: 'fileEmails',
        component: () => import( /* webpackChunkName: "fileEmails" */ '@/views/file/FileEmails.vue')
    },
    {
        path: '/files/:id/uploadFiles/:uploadFileId/share',
        name: 'uploadFileShare',
        component: () => import( /* webpackChunkName: "uploadFileShare" */ '@/views/file/UploadFileShare.vue')
    },
    {
        path: '/file/:id',
        name: 'file',
        component: () => import( /* webpackChunkName: "file" */ '@/views/file/File.vue')
    },
    {
        path: '/instructions',
        name: 'instructions',
        component: () => import( /* webpackChunkName: "instructions" */ '@/views/file/Instructions.vue')
    },
    {
        path: '/matterList/:teamId?',
        name: 'matterList',
        component: () => import( /* webpackChunkName: "matterList" */ '@/views/file/MatterList.vue')
    },
    {
        path: '/monthlySummary',
        name: 'monthlySummary',
        component: () => import( /* webpackChunkName: "monthlySummary" */ '@/views/file/MonthlySummary.vue')
    },
    {
        path: '/operatorClients/list',
        name: 'operatorClients',
        component: () => import( /* webpackChunkName: "operatorClients" */ '@/views/file/OperatorClients.vue')
    },
    {
        path: '/operatorClients/view/:id',
        name: 'operatorClient',
        component: () => import( /* webpackChunkName: "operatorClient" */ '@/views/file/OperatorClient.vue')
    },
    {
        path: '/operators/list',
        name: 'operators',
        component: () => import( /* webpackChunkName: "operators" */ '@/views/file/Operators.vue')
    },
    {
        path: '/operators/view/:id',
        name: 'operator',
        component: () => import( /* webpackChunkName: "operator" */ '@/views/file/Operator.vue')
    },
    {
        path: '/os1',
        name: 'os1',
        component: () => import( /* webpackChunkName: "os1" */ '@/views/file/Os1.vue')
    },
    {
        path: '/os1expiring',
        name: 'os1expiring',
        component: () => import( /* webpackChunkName: "os1expiring" */ '@/views/file/Os1Expiring.vue')
    },
    {
        path: '/os1Monthly',
        name: 'os1Monthly',
        component: () => import( /* webpackChunkName: "os1Monthly" */ '@/views/file/Os1Monthly.vue')
    },
    {
        path: '/pcws/list',
        name: 'pcws',
        component: () => import( /* webpackChunkName: "pcws" */ '@/views/file/Pcws.vue')
    },
    {
        path: '/pcws/view/:id',
        name: 'pcw',
        component: () => import( /* webpackChunkName: "pcw" */ '@/views/file/Pcw.vue')
    },
    {
        path: '/undertakings',
        name: 'undertakings',
        component: () => import( /* webpackChunkName: "undertakings" */ '@/views/file/UndertakingReport.vue')
    }
]